// extracted by mini-css-extract-plugin
export default {"topCon":"topCon--T_avp","titleCon":"titleCon--PU8i4","slotCon":"slotCon--KzLfa","descCon":"descCon--yehMU","markerAnimationScale":"markerAnimationScale--vlwbK"};